import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

import './logo.scss';

function Logo() {
    
    return (
        <div className="logo-container">
            <AutoAwesomeIcon className="logo-icon" />
            <h2 className="logo-text">Starflix</h2>
        </div>
    )
}

export default Logo;